// Telas de detalhe que pertencem a uma seção do menu mas moram fora do prefixo de rota
// dela. A seleção do menu é por prefixo (`/`, `/action`, `/library`, `/class`), então uma
// página em outro prefixo não acenderia nada.
//
// /manage-assignment/:id substituiu a modal de histórico que era aberta de dentro de
// "Atribuições": antes o botão levava para /action/:id/info e a seção seguia acesa, então a
// página nova precisa continuar contando como "Atribuições".
//
// Fonte única para os dois consumidores: a barra inferior (`isActive` próprio) e o menu
// lateral (via `matchRoutes` de `NavbarMenuItemType`, do design-system).
export const SECTION_MATCH_ROUTES: Readonly<Record<string, readonly string[]>> = {
  "/action": ["/manage-assignment"]
};
